<ansyn-loader [show]="show" [loaderText]="loaderText | translate" [rtl]="'rtl' === ('direction' | translate)"></ansyn-loader>
